import React, { Component, PropTypes } from 'react';
import { makeSlug, geti18n, formatCurrency } from '../../../../utils';
import { optionTypes, paymentTypes } from '../../../../redux/constants';
import OfferSummary from './components/OfferSummary';
import OfferModal from './components/OfferModal';
import ErrorMessage from '../../../../components/ErrorMessage';
import './styles';

/**
 * Displays the Card based on the offertype passed in (LEASE or FINANCE)
 * Options come in from BestOfferProvider
 */
class BestOfferCard extends Component {
  static propTypes = {
    // Properties required to be passed in from the provider
    brand: PropTypes.string.isRequired,
    paymentType: PropTypes.string.isRequired,
    optionType: PropTypes.string.isRequired,
    isOfferApplied: PropTypes.bool.isRequired,
    isOfferAppliedPending: PropTypes.bool.isRequired,
    monthlyPayment: PropTypes.string.isRequired,
    offerSummary: PropTypes.string.isRequired,
    offerDescription: PropTypes.string.isRequired,
    mileageOptions: PropTypes.array.isRequired,
    financeDropdownOptions: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
    selectedTerm: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    termOptions: PropTypes.array.isRequired,
    selectedMileage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    selectedDropdownOption: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    userTradeIn: PropTypes.string.isRequired,
    userDownPayment: PropTypes.string.isRequired,
    acquisitionFee: PropTypes.string.isRequired,
    popularEquippedPrice: PropTypes.string.isRequired,
    cashBackAmount: PropTypes.string,
    residualValue: PropTypes.number,

    // Actions (passed from provider)
    viewOfferDetailsAction: PropTypes.func.isRequired,
    changeTermAction: PropTypes.func.isRequired,
    changeMileageAction: PropTypes.func.isRequired,
    changeOfferSelectionAction: PropTypes.func.isRequired,
    handleModalClosedAction: PropTypes.func.isRequired,

    // Labels
    viewOfferDetailsLabel: PropTypes.string,
    perMonthLabel: PropTypes.string,
    cashbackLabel: PropTypes.string,
    estimatedAmountLabel: PropTypes.string,
    adjustedCostLabel: PropTypes.string,
    aquisitionFeeLabel: PropTypes.string,
    popularEquippedLabel: PropTypes.string,
    msrpLabel: PropTypes.string,

    // Payment Option Errors
    leaseErrorLabel: PropTypes.string.isRequired,
    financeErrorLabel: PropTypes.string.isRequired,
    errorTitle: PropTypes.string.isRequired,
    reduceLeasePaymentErrorLabel: PropTypes.string.isRequired,
    financeLowerLimitLabel: PropTypes.string.isRequired,
    estimatedAmount: PropTypes.string,
    adjustedCost: PropTypes.string,
    dueAtSigning: PropTypes.string,

    // NEW for PHASE 1 CHANGES
    leaseHeading: PropTypes.string,
    financeHeading: PropTypes.string,
    apr: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    aprLabel: PropTypes.string,
    tradeInLabel: PropTypes.string,
    downPaymentLabel: PropTypes.string,
    totalPriceTitle: PropTypes.string,
    totalPrice: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    modelLine: PropTypes.string.isRequired,
    promoTypeId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,

  };
  static defaultProps = {
    // Labels
    viewOfferDetailsLabel: geti18n('offerPanel.topPanel.detailsText'),
    perMonthLabel: geti18n('offerPanel.detailsModal.month'),
    addOfferLabel: geti18n('offerPanel.topPanel.addOffer'),
    removeOfferLabel: geti18n('offerPanel.topPanel.removeOffer'),
    termLabel: geti18n('offerPanel.topPanel.termText'),
    aprLabel: geti18n('offerPanel.topPanel.apr'),
    cashbackLabel: geti18n('offerPanel.topPanel.cashBackTitle'),
    mileageLabel: geti18n('offerPanel.topPanel.mileage'),
    estimatedAmountLabel: geti18n('offerPanel.summaryPanel.estimatedAmount'),
    adjustedCostLabel: geti18n('offerPanel.summaryPanel.adjustedCost'),
    personalizedAmountLabel: geti18n('offerPanel.summaryPanel.estimatedAmountText'),
    aquisitionFeeLabel: geti18n('offerPanel.summaryPanel.aquisitionFee'),
    requiredInitialLabel: geti18n('offerPanel.summaryPanel.requiredDownPayment'),
    popularEquippedLabel: geti18n('trimSelectPanel.popularEquippedLabel'),
    msrpLabel: geti18n('offerPanel.summaryPanel.msrp'),

    // Disclaimers
    aprDisclaimer: geti18n('offerPanel.topPanel.aprDisclaimer'),
    cashbackDisclaimer: geti18n('offerPanel.topPanel.cashBackDisclaimer'),

    // Payment Option Errors
    leaseErrorLabel: geti18n('paymentOptionError.leaseMessage'),
    financeErrorLabel: geti18n('paymentOptionError.financeMessage'),
    errorTitle: geti18n('paymentOptionError.title'),
    reduceLeasePaymentErrorLabel: geti18n('paymentOptionError.reduceLeasePaymentError'),
    financeLowerLimitLabel: geti18n('paymentOptionError.financeLowerLimit'),

    offerSummary: '',
    offerDescription: '',
    selectedMileage: '',
    selectedCashBack: '',
    isAPROffer: false,
    cashBackAmount: undefined,
    residualValue: undefined,

    estimatedAmount: '',
    adjustedCost: '',
    dueAtSigning: '',

    // NEW FOR PHASE 1 CHANGES
    leaseHeading: geti18n('paymentTypes.lease'),
    financeHeading: geti18n('paymentTypes.finance'),
    apr: '',
    tradeInLabel: geti18n('personalizePanel.tradeIn'),
    downPaymentLabel: geti18n('personalizePanel.downPayment'),
    totalPriceTitle: geti18n('offerPanel.summaryPanel.totalPrice'),
    financeDropdownOptions: []
  };

  getOfferHeaderClassNames() {
    const { isOfferApplied, optionType } = this.props;
    const classNames = ['offer-top'];
    if (isOfferApplied && optionType === optionTypes.OFFER) {
      classNames.push('offer-applied')
    }
    return classNames.join(' ');
  }

  /* There is a bunch of business logic happens
  here that should probably be handled before it gets here.  */
  hasErrors() {
    const {
      monthlyPayment,
      isOfferApplied,
      paymentType,
      leaseErrorLabel,
      financeErrorLabel,
      reduceLeasePaymentErrorLabel,
      financeLowerLimitLabel,
      residualValue,
      adjustedCost,
      estimatedAmount,
      popularEquippedPrice,
      cashBackAmount,
      selectedTerm
    } = this.props;

    // Monthly Payment cannot exceed $10000.
    const monthlyPaymentCap = 10000;
    const monthlyPaymentValue = parseInt(monthlyPayment.replace(/[$,]+/g, ''), 10);
    if (isOfferApplied && monthlyPaymentValue > monthlyPaymentCap) {
      return paymentType === 'LEASE' ? leaseErrorLabel : financeErrorLabel;
    }

    // For Lease Offers The adjustedCapitalCost must be greater than residuleValue plus $100.
    // eslint-disable-next-line
    const adjustCstVal = parseInt(adjustedCost.replace(/[$,]+/g, ''), 10);
    const residualAdj = residualValue + 100;
    if (paymentType === 'LEASE' && (adjustCstVal < residualAdj)) {
      const amt = formatCurrency(residualAdj);
      return reduceLeasePaymentErrorLabel.replace(/\${amt}/g, amt)
    }

    // For Finace options the total amount financed must
    // be at least 15000 for Nissan and 7500 for Infiniti

    if (paymentType === 'FINANCE' && cashBackAmount) {
      const cashBackVal = parseInt(cashBackAmount.replace(/[$,]+/g, ''), 10);
      const amtVal = parseInt(estimatedAmount.replace(/[$,]+/g, ''), 10)
      const threshold = selectedTerm > 60 ? 15000 : 7500;
      const popPrice = parseInt(popularEquippedPrice.replace(/[$,]+/g, ''), 10);
      const adjustedCashbackPrice = popPrice - cashBackVal;

      if (amtVal < threshold) {
        const amt = formatCurrency(threshold);
        const term = selectedTerm;
        const limit = formatCurrency(adjustedCashbackPrice - threshold);

        return financeLowerLimitLabel
          .replace(/\${amt}/g, amt)
          .replace(/\${term}/g, term)
          .replace(/\${limit}/g, limit);
      }
    }

    // return nothing if we have no errors
    return undefined;
  }

  renderTitle() {
    const {
      monthlyPayment,
      isOfferApplied,
      perMonthLabel,
      leaseHeading,
      financeHeading,
      paymentType,
      viewOfferDetailsLabel,
      viewOfferDetailsAction,
      offerSummary
    } = this.props;

    const titleMsg = paymentType === 'LEASE' ? leaseHeading : financeHeading;
    const errorMessage = this.hasErrors();
    const amount = errorMessage ? 'N/A' : monthlyPayment;
    let specialPricingButton = '';
    let specialPricingSummary = '';
    if (isOfferApplied) {
      specialPricingButton = <span className="offer-details"><button onClick={viewOfferDetailsAction}>{viewOfferDetailsLabel}&nbsp;&gt;</button></span>;
      specialPricingSummary = <p className="term-description arial-text">{offerSummary}</p>
    }

    return (
      <div className="payment-option-title offer-title row">
        <span className="columns small-6 offer-label">
          <span className="heading-first">{titleMsg}</span>
          { specialPricingButton }
          { specialPricingSummary }
        </span>
        <span className="columns small-6 offer-monthly-payment">
          <span className="offer-monthly-payment-amount heading-first">{amount}</span>
          <span className="offer-monthly-payment-label heading-third">{perMonthLabel}</span>
        </span>
      </div>
    )
  }

  renderHeader() {
    const headerClassName = this.getOfferHeaderClassNames();
    const errorMessage = this.hasErrors();
    return (
      <div className={headerClassName}>
        {this.renderTitle()}
        {errorMessage ? this.renderError(errorMessage) : undefined}
      </div>
    )
  }

  renderSummary() {
    const {
      monthlyPayment,
      estimatedAmountLabel,
      adjustedCostLabel,
      aquisitionFeeLabel,
      popularEquippedLabel,
      userTradeIn,
      userDownPayment,
      acquisitionFee,
      popularEquippedPrice,
      paymentType,
      selectedTerm,
      estimatedAmount,
      adjustedCost,
      dueAtSigning,
      termOptions,
      changeTermAction,
      optionType,
      selectedMileage,
      selectedDropdownOption,
      mileageOptions,
      financeDropdownOptions,
      changeMileageAction,
      changeOfferSelectionAction,
      apr,
      aprLabel,
      cashbackLabel,
      tradeInLabel,
      downPaymentLabel,
      msrpLabel,
      brand,
      totalPriceTitle,
      totalPrice,
      cashBackAmount,
      modelLine,
      promoTypeId,
      isOfferApplied

    } = this.props;

    // Nissan Coloring
    const summaryColor = brand === 'nissan' ? 'blue' : '';

    // Acquisition Row
    const acquisitionRow = acquisitionFee !== '$0'
        ? { label: aquisitionFeeLabel, value: acquisitionFee }
        : undefined;

    // APR Row
    const aprRow = paymentType === 'FINANCE' ? { label: aprLabel, value: `${apr}%` } : undefined;

    // Adjusted Capitalized Cost Row
    let adjustedCapitalizedRow;
    const cashBackRow = (cashBackAmount) && (cashBackAmount !== '$0') ? { label: cashbackLabel, value: `(${cashBackAmount})`, className: summaryColor } : undefined; //eslint-disable-line
    if (paymentType === 'LEASE') {
      adjustedCapitalizedRow = { label: adjustedCostLabel, value: adjustedCost }; //eslint-disable-line
    }

    // Estimated Amount Row
    let estimatedAmountRow;
    if (paymentType === 'FINANCE') {
      estimatedAmountRow = { label: estimatedAmountLabel, value: estimatedAmount }; //eslint-disable-line
    }

    const tradeInRow = { label: tradeInLabel, value: `(${userTradeIn})`, className: summaryColor };
    const downPaymentRow = { label: downPaymentLabel, value: `(${userDownPayment})`, className: summaryColor };

    // Popularly equipped price OR MSRP
    const priceLabel = (paymentType === paymentTypes.LEASE && optionType === optionTypes.OFFER)
      ? msrpLabel
      : popularEquippedLabel;
    const popularPriceRow = { label: priceLabel, value: popularEquippedPrice };

    // Helios Total Price Value Row
    const totalPriceRow = { label: totalPriceTitle, value: totalPrice };

    const priceRow = totalPrice ? totalPriceRow : popularPriceRow;

    // summary items
    const summaryItems = [
      priceRow,
      aprRow,
      acquisitionRow,
      cashBackRow,
      tradeInRow,
      downPaymentRow,
      adjustedCapitalizedRow,
      estimatedAmountRow,
    ].filter(Boolean);

    const errorMessage = this.hasErrors();
    const amount = errorMessage ? 'N/A' : monthlyPayment;

    return (
      <OfferSummary
        selectedTerm={selectedTerm}
        termOptions={termOptions}
        changeTermAction={changeTermAction}
        changeOfferSelectionAction={changeOfferSelectionAction}
        optionType={optionType}
        paymentType={paymentType}
        selectedMileage={selectedMileage}
        selectedDropdownOption={selectedDropdownOption}
        mileageOptions={mileageOptions}
        financeDropdownOptions={financeDropdownOptions}
        changeMileageAction={changeMileageAction}
        summaryItems={summaryItems}
        monthlyPayment={amount}
        signingAmount={dueAtSigning}
        modelLine={modelLine}
        brand={brand}
        cashBackAmount={cashBackAmount}
        promoTypeId={promoTypeId}
        isOfferApplied={isOfferApplied}
      />
    );
  }

  renderModal() {
    const {
      optionType,
      offerDescription,
      isOfferAppliedPending,
      monthlyPayment,
      isOfferApplied,
      handleModalClosedAction,
      paymentType,
    } = this.props;
    if (optionType !== optionTypes.OFFER) {
      return undefined;
    }
    const titleTerm = `offerModal.${paymentType.toLowerCase()}.${optionType.toLowerCase()}`;
    const modalTitle = geti18n(titleTerm);
    return (<OfferModal
      modalOpen={isOfferAppliedPending}
      offerApplied={isOfferApplied}
      title={modalTitle}
      fullOfferDescription={offerDescription}
      paymentType={paymentType}
      optionType={optionType}
      monthlyPayment={monthlyPayment}
      onClose={handleModalClosedAction}
    />)
  }

  renderError(msg) {
    const { errorTitle, brand } = this.props;
    // eslint-disable-next-line
    console.log('errorTitle', errorTitle);

    // Need to set the SVG color to black for Infiniti or white for Nissan
    const errorColor = brand === 'nissan' ? '#fff' : '#000';
    const invalidTitle = geti18n('paymentOptionError.invalid');
    return (
      <div className="offer-payment-too-high">
        <ErrorMessage title={invalidTitle} message={msg} classes={errorColor} />
      </div>
    )
  }

  renderErrorScreen() {
    const errorMessage = this.hasErrors();
    if (!errorMessage) {
      return undefined;
    }
    return (
      <div className="payment-option-error-screen">&nbsp;</div>
    )
  }

  renderBody() {
    return (
      <div className="offers-panel">
        {this.renderHeader()}
        {this.renderSummary()}
        {this.renderModal()}
        {this.renderErrorScreen()}
      </div>
    )
  }

  render() {
    const { paymentType, optionType } = this.props;
    const className = `payment-option-list-item ${makeSlug(paymentType)} ${makeSlug(optionType)}`;
    return (
      <div className={className}>
        <div className="payment-option">
          {this.renderBody()}
        </div>
      </div>
    );
  }
}

export default BestOfferCard;




/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferCard/index.js
 **/